import React from 'react';
import PropTypes from 'prop-types';
import { calculatePercentage } from 'utils/misc';
import millify from 'utils/millify';
import StatBarItemSlim from 'components/StatBar/StatBarItemSlim';

const ContactStats = ({
  totalContacts,
  optouts,
  blacklisted,
  bounces,
  delivered,
  opened,
  replies,
  uniqueDelivered,
  uniqueAttemptedSends,
}) => (
  <div className="flex items-center">
    <StatBarItemSlim label="Total Contacts" value={millify(totalContacts)} />
    <hr className="w-3 my-0 mx-4 rotate-90" />
    <StatBarItemSlim label="Opted out" value={optouts !== null ? optouts : '-'} />
    <hr className="w-3 my-0 mx-4 rotate-90" />
    <StatBarItemSlim label="Do not contact" value={blacklisted !== null ? blacklisted : '-'} />
    <hr className="w-3 my-0 mx-4 rotate-90" />
    <StatBarItemSlim label="Delivered" value={millify(delivered)} />
    <hr className="w-3 my-0 mx-4 rotate-90" />
    <StatBarItemSlim
      label="Bounced"
      value={`${calculatePercentage(uniqueAttemptedSends, bounces)}%`}
      valueAffix={millify(bounces)}
    />
    <hr className="w-3 my-0 mx-4 rotate-90" />
    <StatBarItemSlim
      label="Opened"
      value={`${calculatePercentage(uniqueDelivered, opened)}%`}
      valueAffix={millify(opened)}
    />
    <hr className="w-3 my-0 mx-4 rotate-90" />
    <StatBarItemSlim
      label="Replied"
      value={`${calculatePercentage(uniqueDelivered, replies)}%`}
      valueAffix={millify(replies)}
    />
  </div>
);

ContactStats.propTypes = {
  totalContacts: PropTypes.number,
  optouts: PropTypes.number,
  blacklisted: PropTypes.number,
  bounces: PropTypes.number,
  delivered: PropTypes.number,
  opened: PropTypes.number,
  replies: PropTypes.number,
  uniqueDelivered: PropTypes.number,
  uniqueAttemptedSends: PropTypes.number,
};

ContactStats.defaultProps = {
  totalContacts: null,
  optouts: null,
  blacklisted: null,
  bounces: null,
  delivered: null,
  opened: null,
  replies: null,
  uniqueDelivered: null,
  uniqueAttemptedSends: null,
};

export default ContactStats;
